import React from "react";

import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";

import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardBody.jsx";

import NavPills from "common/components/NavPills/NavPills.jsx";

import Table from "common/components/Table/Table.jsx";

// @material-ui/core components
import CallReceived from "@material-ui/icons/CallReceived";
import CallMade from "@material-ui/icons/CallMade";

import Hidden from "@material-ui/core/Hidden";

import loadContent from "core-module/hoc/loadContent";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import withStyles from "@material-ui/core/styles/withStyles";

const importedStyle = dashboardStyle;

const styles = {
  cardCategory: importedStyle.cardCategory,
  cardTitle: importedStyle.cardTitle,
  datainfo: {
    ...importedStyle.cardTitle,
    textAlign: "right",
    paddingRight: "20px"
  },
  cardIconTitle: {
    ...importedStyle.cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  labelHorizontal: {
    justifyContent: "center"
  },
  containerLine: {
    marginTop: "20px"
  },
  editButton: {
    textAlign: "right",
    margin: "10px"
  },
  maxHeight: {
    maxHeight: "400px"
  }
};

const IncomingHistory = props => {
  return (
    <Table
      tableHead={["From", "Date", "Duration"]}
      tableData={props.getList(
        (oGet, id) => {
          return [
            /a-zA-Z/.test(oGet("src_call_name"))
              ? oGet("src_call_name") + oGet("src_call_number")
              : oGet("src_call_number"),
            oGet("callstartdate"),
            oGet("duration")
          ];
        },
        () => [],
        "DESC"
      )}
    />
  );
};

const IncomingHistoryCard = withStyles(styles)(
  loadContent(
    "user.session/billingpackage.props/billingpackageservice.props/voipcdri",
    IncomingHistory
  )
);

const OutgoingHistory = props => {
  return (
    <Table
      fullWidth
      tableHead={["To", "Date", "Duration"]}
      tableData={props.getList(
        (oGet, id) => {
          return [
            oGet("dst_call_number"),
            oGet("callstartdate"),
            oGet("duration")
          ];
        },
        () => [],
        "DESC"
      )}
    />
  );
};

const OutgoingHistoryCard = withStyles(styles)(
  loadContent(
    "user.session/billingpackage.props/billingpackageservice.props/voipcdro",
    OutgoingHistory
  )
);

const CallsHistory = props => {
  const { classes } = props;
  const voipbps = props.getData("id");
  return (
    <div>
      <Hidden mdUp>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <CallReceived />
            </CardIcon>
            <h4 className={classes.cardIconTitle}> Calls History</h4>
          </CardHeader>
          <CardBody>
            <NavPills
              alignCenter
              color="primary"
              tabs={[
                {
                  tabButton: "Incoming",
                  tabContent: (
                    <IncomingHistoryCard
                      pathids={{
                        billingpackage: props.ids.billingpackage,
                        billingpackageservice: voipbps
                      }}
                    />
                  )
                },
                {
                  tabButton: "Outgoing",
                  tabContent: (
                    <OutgoingHistoryCard
                      pathids={{
                        billingpackage: props.ids.billingpackage,
                        billingpackageservice: voipbps
                      }}
                    />
                  )
                }
              ]}
            />
          </CardBody>
        </Card>
      </Hidden>

      <Hidden smDown>
        <GridContainer className={classes.containerLine} alignItems="center">
          <GridItem xs={12} sm={12} md={6} lg={6}>
            <Card>
              <CardHeader color="primary" icon>
                <CardIcon color="primary">
                  <CallReceived />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Incoming</h4>
              </CardHeader>
              <CardBody>
                <IncomingHistoryCard
                  pathids={{
                    billingpackage: props.ids.billingpackage,
                    billingpackageservice: voipbps
                  }}
                />
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} lg={6}>
            <Card>
              <CardHeader color="primary" icon>
                <CardIcon color="primary">
                  <CallMade />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Outgoing</h4>
              </CardHeader>
              <CardBody>
                <OutgoingHistoryCard
                  pathids={{
                    billingpackage: props.ids.billingpackage,
                    billingpackageservice: voipbps
                  }}
                />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </Hidden>
    </div>
  );
};

export default withStyles(styles)(
  loadContent(
    "user.session/billingpackage.props/billingpackageservice_voip",
    CallsHistory
  )
);
